import React from "react";
import { Row, Col } from "antd";
import profile from "../../../../assets/icons/profile-3.svg";
import history from "../../../../history/history";
import { EditButtonComponent } from "../../../../CommonComponents/CTA/Buttons";
import {
  DataHeading,
  SectionLastHeading,
  BlurContainer,
  BlurOverlay
} from "../../../../CommonComponents/commonStyles";

import { initiateTracking, recordError } from "../../../../utils/commonUtil";
import { PillButtonAdd } from "../Step1Setup/styles";
import {
  PersonnelHeading,
  AddAdvisorLinkButton,
  AlignItemsCenterNew
} from "../../styles";
import Advisor from "./Advisor";
import { isGeminiUser, getPrimaryAccount } from '../../../../utils/sessionUtil';
import CSREditLinkToPill from "../../../../CommonComponents/EditLinkToPill/CSREditLinkToPill";
import { ContentMessage, Types } from '../../../../CommonComponents/ContentMessages';
import { CapsuleButton } from "../../../../CommonComponents/Commons/commonComponents";

export let heading = {
  title: "My Account",
  subTitle: 'Account Advisors',
  buttonText: ["Edit", "Add Secondary Advisor"]
}

export const editAdvisor = function (advisorType) {
  initiateTracking("edit", heading.title(), heading.subTitle, heading.buttonText[0]);
  history.push("/my-account/edit", { "advisorType": advisorType });
}

export const addSecAdvisor = () => {
try
{
  initiateTracking("addSecondaryAdvisor", heading.title(), heading.subTitle, heading.buttonText[1]);
  history.push("/my-account/edit", { addSecondaryAdv: true });
} catch (error) {
  recordError(error);
}
}


export const setAdvisorTitle = (title='') => {
  if(title) heading.subTitle = title;
}

function AccountAdvisorSection({ edit, blur, advisors, advisorType, accData, countryCodeMappingData, addSecondaryDisable, pageTitle }) {
  const { secondaryAdvisorCaseCreated } = accData;  
  heading.title = pageTitle;
  advisors.sort((a, b) => b.primaryAdvisor - a.primaryAdvisor);
  return (
    <BlurContainer className="change-account-advisor">
      <BlurOverlay isEnabled={blur} />
      <AlignItemsCenterNew>
        <SectionLastHeading className="mb0">          
          <ContentMessage data-test="content-message" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_type_1_title" defaultMessage="Account Advisors" setTitle={(title)=>{ setAdvisorTitle(title)} } />
        </SectionLastHeading>
        <div id="btnAccountAdvisorEdit">
          <EditButtonComponent
            data-test = "btnAccountAdvisorEdit"
            className="ml-10"
            disabled={edit}
            buttonName={heading.buttonText[0]}
            clicked={()=>{editAdvisor(advisorType)}}
          />
        </div>

        { isGeminiUser() && <CSREditLinkToPill
          className='ml-15 accountAdvisorCsrEdit'
          toGeminiApp={true}
          linkPathname={`/vceptpl/csr/acctmaint/editAcctAdvisors.do?dafAccountId=${getPrimaryAccount().userId}`}
          />
        }
      </AlignItemsCenterNew>
      <Row>
        {advisors.map((item, index) =>
          advisors.length > 1 ? (
            <Advisor key={index} advisorInfo={item} countryCodeMappingData={countryCodeMappingData} />
          ) : (
              <>
                <Advisor key={index} advisorInfo={item} countryCodeMappingData={countryCodeMappingData} />
                <Col lg={8} md={8} xs={24}>
                  <Row>
                    <Col lg={2} md={2} xs={2}>
                      <img src={profile} alt="secondaryProfileIcon" />
                    </Col>
                    <Col lg={22} md={22} xs={22}>
                      <PersonnelHeading>Secondary Advisor</PersonnelHeading>
                      {
                        !secondaryAdvisorCaseCreated ? (
                          <DataHeading>No Records Found</DataHeading>
                        ) : (
                            <DataHeading>Your request to add secondary advisor is under process and will be updated soon.</DataHeading>
                          )
                      }
                      <AddAdvisorLinkButton className="mt0 my-account-linkDisable">
                        <CapsuleButton id="btnAddSecondaryAdvisor"
                          onClick={addSecAdvisor}
                          disabled={addSecondaryDisable || secondaryAdvisorCaseCreated}
                          text={`${heading.buttonText[1]} +` } 
                          >
                        </CapsuleButton>
                      </AddAdvisorLinkButton>
                    </Col>
                  </Row>
                </Col>
              </>
            )
        )}
      </Row>
    </BlurContainer>
  );
}

export default AccountAdvisorSection;
